/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const justifyCenter = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M20 9h-7.2V4h-1.6v5H4v6h7.2v5h1.6v-5H20z" />
	</SVG>
);

export default justifyCenter;
